var globalFunc = {
	init: function(){
		globalFunc.resize();
	},
	get_biggest: function(elements){
		//get all elements with class and get the biggest box
		var biggest_height = 0;
		for ( var i = 0; i < elements.length ; i++ ){
			var element_height = $(elements[i]).outerHeight();
			//compare the height, if bigger, assign to variable
			if(element_height > biggest_height ) biggest_height = element_height;
		}
		return biggest_height;
	},
	resize: function(){
		var windowWidth = $(window).width();
		var windowHeight = $(window).height();

		// STICKY FOOTER
		var headerHeight = $('header').outerHeight();
		var footerHeight = $('footer').outerHeight();
		var footerTop = (footerHeight) * -1;
		$('footer').css({marginTop: footerTop});
		$('#main-wrapper').css({paddingBottom: footerHeight});

		// for vertically middle content
		$('.bp-middle').each(function() {
			var bpMiddleHeight = $(this).outerHeight() / 2 * - 1;
			$(this).css({marginTop: bpMiddleHeight});
		});

		// for equalizer
		$('.classname').css({minHeight: 0});
		var ClassName = globalFunc.get_biggest($('.classname'));
		$('.classname').css({minHeight: ClassName});
	},
	touch: function(){
		if (Modernizr.touch) {
			$('html').addClass('bp-touch');
		}
	},

	fullPage: function(){
		$('#page-scroll').fullpage({
			autoScrolling:true,
			scrollHorizontally: true,
			responsiveWidth: 1367,
			fadingEffect: true,
			scrollOverflow: true,
		});

		//methods
		$.fn.fullpage.setAllowScrolling(true);

		$('.scroll-down-btn' ).click(function(){
			$.fn.fullpage.moveSectionDown();
		});
	},
	animateMeter: function(){

		$('.mc-milestone-container').appear(function(){
			var progress = $('#progress-bar'); //select the element value
			var meterMax = progress.attr('max'); //get the max value
			var meterValue = progress.attr('value'); //get the current value
			var quarterValue = Math.round(meterMax / 3); //divide the max into four parts
			var timeout = 1100;
			var percentValue = (meterValue / meterMax) * 100; //get percentage from 1 to 100

			function fillMeter(){
				progress.animate({'width': percentValue+"%"}, 1000);
			}

			//show the bonus box progress of milestone if by custom percentage
			if(meterValue == meterMax){
				//if achieved 100%
				fillMeter();
				setTimeout(function(){
					$('.bonus-box').addClass('passed');
				},timeout);
			}else if(meterValue > meterMax && percentValue >=100){
				fillMeter();
				setTimeout(function(){
					$('.bonus-box').addClass('passed');
				},timeout);
			// }else if(meterValue !== meterMax && percentValue >=53.3){
			}else if(meterValue !== meterMax && meterValue >= 800000){
				//if achieved 53%
				fillMeter();
				setTimeout(function(){
					$('.bb-1, .bb-2').addClass('passed');
				},timeout);
			// }else if(percentValue >= 20){
			}else if(meterValue >= 300000){
				//if achieved 20%
				fillMeter();
				setTimeout(function(){
					$('.bb-1').addClass('passed');
				},timeout);
			}else{
				fillMeter();
			}
		});
	},
	counter: function(){
		$('.counter').each(function() {
			var $this = $(this),
					countTo = $this.attr('data-count');
			$({ countNum: $this.text()}).animate({
				countNum: countTo
			},
			{
				duration: 1400,
				easing:'linear',
				step: function() {
					$this.text(Math.floor(this.countNum));
				},
				complete: function() {
					$this.text(this.countNum);
					//alert('finished');
				}
			});
		});
	},
	customSelect: function(){
		//custom select
		$('select.custom-select').each(function() {
			$(this).wrap('<div class="custom-select-wrapper" />');
			$(this).before('<div class="custom-select-display" />');
			$(this).change(function() {
				var selectedOpt = $(this).find('option:selected');
				var defValue = $(selectedOpt).attr('value');
				$(this).siblings('.custom-select-display').text($(selectedOpt).text());
				if(defValue == 'default') {
					$(this).siblings('.custom-select-display').addClass('default');
				} else {
					$(this).siblings('.custom-select-display').removeClass('default');
				}
			});
			$(this).keyup(function() {
				var selectedOpt = $(this).find('option:selected');
				var defValue = $(selectedOpt).attr('value');
				$(this).siblings('.custom-select-display').text($(selectedOpt).text());
				if(defValue == 'default') {
					$(this).siblings('.custom-select-display').addClass('default');
				} else {
					$(this).siblings('.custom-select-display').removeClass('default');
				}
			});
			$(this).change();
		});
	},

	slickSlider: function(){
		// $('.product-carousel').slick({
		// 	setting-name: setting-value
		// });
		$('.slider-for').slick({
	   slidesToShow: 1,
	   slidesToScroll: 1,
	   arrows: false,
	   fade: true,
	   asNavFor: '.slider-nav'
	 });
	 $('.slider-nav').slick({
	   slidesToShow: 4,
	   slidesToScroll: 1,
	   asNavFor: '.slider-for',
	   dots: false,
	   centerMode: false,
	   focusOnSelect: true
	 });
	},
	videoModal: function(){
		$('.placeholder-vid').on('click', function(ev) {
			var ytId = $(this).attr('data-ytId');
			$("#videoScreen")[0].src += "?autoplay=1&loop=1&playlist="+ytId+"&amp;showinfo=0";
			$(this).fadeOut(1000);
			
			ev.preventDefault();
		});
	},

	selectMilestone: function(){

		var isLargeWindow;
		var windowWidth = $(window).width();

		$('.bonus-box').on('click', function(event){
			event.stopPropagation();
			if(windowWidth <= 768){
				var bbTarget = $(this).attr('data-target');

				//add class active on bonus box
				$(this).addClass('active').siblings().removeClass('active hover');

				//add class active on targeted id
				$("#"+bbTarget).addClass('active').siblings('.bb-milestones-mobile').removeClass('active');

			}else{
				$('.bonus-box').removeClass('active');
			}
		});

		$(document).click( function() {
			if( $(window).width() >= 768 ){
				$('.bonus-box, .bb-milestones-mobile').removeClass('active');
			}
		});
	},

	showfirstMilestone: function(){
		if( $(window).width() <= 768 ){
			$('.bonus-box, .bb-milestones-mobile').removeClass('active');
			$('#bb-1, .bb-1').addClass('active');
		}else{
			$('body').removeClass('small-screen');
			$('.bonus-box, .bb-milestones-mobile').removeClass('active');
		}
	},

	sparkleCustom: function(){
		//custom starshine
		$('.starshine').each(function(){
			var thisStar = $(this),
				  stars = $(this).attr('data-count'),
			    template = $('<div class="template shine">'),
					sparkle = $(this).attr('data-delay');

			function createStar(){
				template
					.clone().css({
						'top' : (Math.random() * 100) + '%',
						'left' : (Math.random() * 100) + '%',
						webkitAnimationDelay: (Math.random() * sparkle) + 's',
				    mozAnimationDelay: (Math.random() * sparkle) + 's',
				    animationDelay: (Math.random() * sparkle) + 's',
					}).addClass(size).appendTo(thisStar);
			}

			for(var i = 0; i < stars; i++) {
				if(i % 2 === 0) {
					size = 'small';
				} else if(i % 3 === 0) {
					size = 'medium';
				} else {
					size = 'large';
				}
				createStar();
			}
		});

	},

	scrollToDown: function(){
		var scrollables = $('html, body');

		function scrollDown(event){
			var id = $('#sneak-peak');
			var top = $(id).offset().top;

			event.preventDefault();
			scrollables.animate({
					scrollTop: top
			});

		}
		$('.scroll-down-btn').on('click', scrollDown);
	},

	showIframe: function () {
		var frame = $('#frameScreen');
		var frameSrc = frame.attr('data-src');

		frame.css('z-index', 5);
		frame.attr('src', frameSrc).delay(4000).queue(function () {
			$('#frameScreen').css('background', 'none').dequeue();
		});
		$('.frame_thumb').css('z-index', -1);
	}

};

$(window).resize(function() {
	globalFunc.init();
	globalFunc.selectMilestone();
	globalFunc.showfirstMilestone();
});

$(document).ready(function() {
	$('.self-image-loader').preloadImage();
	globalFunc.touch();
	globalFunc.init();
	// globalFunc.animateMeter();
	// globalFunc.fullPage();
	globalFunc.counter();
	globalFunc.customSelect();
	globalFunc.slickSlider();
	globalFunc.videoModal();
	globalFunc.selectMilestone();
	globalFunc.showfirstMilestone();
	globalFunc.sparkleCustom();
	// globalFunc.scrollToDown();
	globalFunc.showIframe();
});

$(window).on('load', function() {
	globalFunc.init();
});

$(function () {
	if (!Modernizr.touch) {
		// $("body").niceScroll();

		if (navigator.userAgent.match(/MSIE 10/i) || navigator.userAgent.match(/Trident\/7\./) || navigator.userAgent.match(/Edge\/12\./)) {
			$('body').on("mousewheel", function () {
				event.preventDefault();
				var wd = event.wheelDelta;
				var csp = window.pageYOffset;
				window.scrollTo(0, csp - wd);
			});
		}
	}
});

// preloader once done
Pace.on('done', function() {
	// totally hide the preloader especially for IE
	setTimeout(function() {
		$('.pace-inactive').hide();
	}, 500);
	globalFunc.animateMeter();
});
